
import React from "react";


const CaptionTable = ({ leftCol, centerCol, rightCol }) => {
    return (
        <div className="d-flex justify-content-between navbar-light">
            <div className="p-2">
                {leftCol}
            </div>
            <div className="p-2">
                {centerCol}
            </div>
            <div className="p-2">
                {rightCol}
            </div>
        </div>
    );
}
export default CaptionTable;